"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PushClient = void 0;
const tslib_1 = require("tslib");
const PushEvent_1 = require("./PushEvent");
const sub_events_1 = require("sub-events");
const Utilities_1 = require("../javascript/Utilities");
class PushClient {
    static SendPing() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (PushClient.WebSocketIsSet())
                yield PushClient.SendWebSocket("");
        });
    }
    static CheckUnreferencedHandler() {
        PushClient.CheckUnreferencedHandlerInternal();
    }
    static ReRegister() {
        PushClient.ReRegisterInternal();
    }
    static CheckUnreferencedHandlerInternal() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let that = this;
            for (let item of that.Store) {
                if (item) {
                    if (item.SubEvent.count < 1) {
                        yield this.DeRegister(item);
                    }
                }
            }
        });
    }
    static ReRegisterInternal() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let that = this;
            yield that.SendPing();
            if (!that.registered) {
                try {
                    that.registered = true;
                    that.m_webSocket = undefined;
                    that.registeredIds2Count = {};
                    const tmpStore = Object.assign([], that.Store);
                    for (let baseItem of tmpStore) {
                        if (!(yield that.Register(baseItem, false))) {
                            that.registered = false;
                            break;
                        }
                    }
                }
                catch (e) {
                    that.registered = false;
                }
                finally {
                    try {
                        if (!that.registered)
                            if (that.m_webSocket != undefined && that.m_webSocket.readyState != WebSocket.CLOSED)
                                that.m_webSocket.close(undefined, "not register after reconnect failed");
                    }
                    catch (e) { }
                }
            }
        });
    }
    static RemoveUnhandledHandles() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let that = this;
            for (let item of that.Store) {
                if (item.SubEvent.count < 1) {
                    yield this.DeRegister(item);
                }
            }
        });
    }
    static AddDocumentChangedEventHandler(handler, docId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.AddDocumentEventHandler(handler, PushEvent_1.EventType.docchanged, docId);
        });
    }
    static AddDocumentDeletedEventHandler(handler, docId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.AddDocumentEventHandler(handler, PushEvent_1.EventType.docdeleted, docId);
        });
    }
    static AddDocumentHardDeletedEventHandler(handler, docId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.AddDocumentEventHandler(handler, PushEvent_1.EventType.docharddeleted, docId);
        });
    }
    static AddDocumentNewEventHandler(handler) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.AddDocumentEventHandler(handler, PushEvent_1.EventType.docnew);
        });
    }
    static AddDocumentNewVersionEventHandler(handler, docId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.AddDocumentEventHandler(handler, PushEvent_1.EventType.docnewversion, docId);
        });
    }
    static AddStructureParentAddedEventHandler(handler, childDocId, childTypeId, parentDocId, parentTypeId, structureType) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.AddStructureEventHandler(handler, PushEvent_1.EventType.parentadded, parentDocId, parentTypeId, childDocId, childTypeId, structureType);
        });
    }
    static AddStructureParentRemovedEventHandler(handler, childDocId, childTypeId, parentDocId, parentTypeId, structureType) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.AddStructureEventHandler(handler, PushEvent_1.EventType.parentremoved, parentDocId, parentTypeId, childDocId, childTypeId, structureType);
        });
    }
    static AddStructureChildAddedEventHandler(handler, parentDocId, parentTypeId, childDocId, childTypeId, structureType) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.AddStructureEventHandler(handler, PushEvent_1.EventType.childadded, parentDocId, parentTypeId, childDocId, childTypeId, structureType);
        });
    }
    static AddStructureChildRemovedEventHandler(handler, parentDocId, parentTypeId, childDocId, childTypeId, structureType) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.AddStructureEventHandler(handler, PushEvent_1.EventType.childremoved, parentDocId, parentTypeId, childDocId, childTypeId, structureType);
        });
    }
    static AddForeigntableChangedEventHandler(handler, name) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.AddForeigntableEventHandler(handler, PushEvent_1.EventType.foreigntablechanged, name);
        });
    }
    static AddDocumentEventHandler(handler, eventType, docId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, _reject) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                let storeItem = undefined;
                switch (eventType) {
                    case PushEvent_1.EventType.docnew:
                        storeItem = this.Store.find(item => item instanceof PushClientDocumentItem && item.Type == eventType);
                        break;
                    case PushEvent_1.EventType.docchanged:
                    case PushEvent_1.EventType.docdeleted:
                    case PushEvent_1.EventType.docharddeleted:
                    case PushEvent_1.EventType.docnewversion:
                        storeItem = this.Store.find(item => item instanceof PushClientDocumentItem && item.Type == eventType && item.DocId === docId);
                        break;
                }
                if (!storeItem) {
                    storeItem = new PushClientDocumentItem(eventType, docId);
                    yield this.Register(storeItem, true);
                }
                let sub = storeItem.SubEvent.subscribe(handler);
                resolve(sub);
            }));
        });
    }
    static AddForeigntableEventHandler(handler, eventType, name) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, _reject) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                let storeItem = undefined;
                switch (eventType) {
                    case PushEvent_1.EventType.foreigntablechanged:
                        storeItem = this.Store.find(item => item instanceof PushClientForeigntableItem && item.Type == eventType && item.Name == name);
                        break;
                }
                if (!storeItem) {
                    storeItem = new PushClientForeigntableItem(name);
                    yield this.Register(storeItem, true);
                }
                let sub = storeItem.SubEvent.subscribe(handler);
                resolve(sub);
            }));
        });
    }
    static AddStructureEventHandler(handler, eventType, parentDocId, parentTypeId, childDocId, childTypeId, structureType) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                let storeItem = undefined;
                switch (eventType) {
                    case PushEvent_1.EventType.childadded:
                    case PushEvent_1.EventType.childremoved:
                    case PushEvent_1.EventType.parentadded:
                    case PushEvent_1.EventType.parentremoved:
                        storeItem = this.Store.find(item => item instanceof PushClientStructureItem && item.Type == eventType && item.ParentTypeId == parentTypeId && item.ParentDocId == parentDocId && item.ChildTypeId == childTypeId && item.ChildDocId == childDocId && item.StructureType == structureType);
                        break;
                }
                if (!storeItem) {
                    storeItem = new PushClientStructureItem(eventType, parentTypeId, parentDocId, childTypeId, childDocId, structureType);
                    yield this.Register(storeItem, true);
                }
                let sub = storeItem.SubEvent.subscribe(handler);
                resolve(sub);
            }));
        });
    }
    static RemoveEventHandler(sub) {
        sub.cancel();
        this.RemoveUnhandledHandles();
    }
    static Register(baseItem, addToStore) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let online = false;
            try {
                let hash = baseItem.RegistrationId;
                let alreadyRegisteredOnCentralHub = hash in this.registeredIds2Count;
                if (addToStore)
                    this.Store.push(baseItem);
                if (!alreadyRegisteredOnCentralHub) {
                    let json = PushEvent_1.MessageObject.toJSON(baseItem.GetMessageObject(PushEvent_1.EventPurpose.register));
                    yield this.SendWebSocket(json);
                    this.registeredIds2Count[hash] = 1;
                }
                else
                    this.registeredIds2Count[hash]++;
                online = true;
            }
            catch (e) {
                this.registered = false;
            }
            return online;
        });
    }
    static DeRegister(baseItem) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                let hash = baseItem.RegistrationId;
                if (this.registeredIds2Count[hash]) {
                    if (this.registeredIds2Count[hash] == 1) {
                        let json = PushEvent_1.MessageObject.toJSON(baseItem.GetMessageObject(PushEvent_1.EventPurpose.deregister));
                        yield this.SendWebSocket(json);
                        delete this.registeredIds2Count[hash];
                    }
                    else
                        this.registeredIds2Count[hash]--;
                }
                let idxToDelete = this.Store.indexOf(baseItem);
                if (idxToDelete != -1)
                    this.Store.splice(idxToDelete, 1);
            }
            catch (e) {
            }
        });
    }
    static WebSocketIsSet() {
        return this.m_webSocket !== undefined && this.m_webSocket.readyState === WebSocket.OPEN;
    }
    static SendWebSocket(message) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let webSocket = yield this.GetWebSocket();
            webSocket.send(message);
        });
    }
    static GetWebSocket() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let that = this;
            return new Promise((resolve, _reject) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                if (!that.m_webSocket) {
                    let socketUrl = window.location.toString();
                    socketUrl = socketUrl.substr(0, socketUrl.length - window.location.hash.length);
                    socketUrl = socketUrl.replace(/^http/, "ws") + "WSProxy.axd?synwss=PushSocket";
                    that.m_webSocket = new WebSocket(socketUrl);
                    that.m_webSocket.addEventListener("open", () => {
                        return resolve(that.m_webSocket);
                    });
                    that.m_webSocket.addEventListener("message", (e) => {
                        try {
                            let jsonMessageObject = JSON.parse(e.data);
                            let messageObject = PushEvent_1.MessageObject.fromJson(jsonMessageObject);
                            let tmpEvent = messageObject.Event;
                            if (tmpEvent && tmpEvent.Purpose == PushEvent_1.EventPurpose.push) {
                                if (tmpEvent instanceof PushEvent_1.DocumentEvent) {
                                    let docEvent = tmpEvent;
                                    switch (tmpEvent.Type) {
                                        case PushEvent_1.EventType.docnew:
                                            for (let item of that.Store) {
                                                if (item instanceof PushClientDocumentItem && item.Type == tmpEvent.Type)
                                                    item.SubEvent.emit(docEvent);
                                            }
                                            break;
                                        case PushEvent_1.EventType.docchanged:
                                        case PushEvent_1.EventType.docdeleted:
                                        case PushEvent_1.EventType.docharddeleted:
                                        case PushEvent_1.EventType.docnewversion:
                                            for (let item of that.Store) {
                                                if (item instanceof PushClientDocumentItem && item.Type == tmpEvent.Type && item.DocId === docEvent.DocId) {
                                                    item.SubEvent.emit(docEvent);
                                                }
                                            }
                                            break;
                                        default:
                                            break;
                                    }
                                }
                                else if (tmpEvent instanceof PushEvent_1.StructureEvent) {
                                    let structureEvent = tmpEvent;
                                    switch (tmpEvent.Type) {
                                        case PushEvent_1.EventType.childadded:
                                        case PushEvent_1.EventType.childremoved:
                                        case PushEvent_1.EventType.parentadded:
                                        case PushEvent_1.EventType.parentremoved:
                                            for (let item of that.Store) {
                                                if (item instanceof PushClientStructureItem && item.Type == tmpEvent.Type) {
                                                    if ((!item.ParentTypeId || (item.ParentTypeId == structureEvent.ParentTypeId)) &&
                                                        (!item.ParentDocId || (item.ParentDocId == structureEvent.ParentDocId)) &&
                                                        (!item.ChildTypeId || (item.ChildTypeId == structureEvent.ChildTypeId)) &&
                                                        (!item.ChildDocId || (item.ChildDocId == structureEvent.ChildDocId)) &&
                                                        (!item.StructureType || (item.StructureType == structureEvent.StructureType)))
                                                        item.SubEvent.emit(structureEvent);
                                                }
                                            }
                                            break;
                                        default:
                                            break;
                                    }
                                }
                                else if (tmpEvent instanceof PushEvent_1.ForeignTableEvent) {
                                    let foreignTableEvent = tmpEvent;
                                    switch (tmpEvent.Type) {
                                        case PushEvent_1.EventType.foreigntablechanged:
                                            for (let item of that.Store) {
                                                if (item instanceof PushClientForeigntableItem && item.Name === foreignTableEvent.Name) {
                                                    item.SubEvent.emit(foreignTableEvent);
                                                }
                                            }
                                            break;
                                        default:
                                            break;
                                    }
                                }
                            }
                        }
                        catch (e) {
                        }
                    });
                    that.m_webSocket.addEventListener("close", () => {
                        that.registered = false;
                        that.m_webSocket = undefined;
                    });
                    that.m_webSocket.addEventListener("error", () => {
                        that.registered = false;
                    });
                }
                else
                    return resolve(that.m_webSocket);
            }));
        });
    }
}
exports.PushClient = PushClient;
PushClient.registered = true;
PushClient.m_webSocket = undefined;
PushClient.Store = [];
PushClient.deRegisterTimer = setInterval(PushClient.CheckUnreferencedHandler, 5000);
PushClient.reRegisterTimer = setInterval(PushClient.ReRegister, 5000);
PushClient.registeredIds2Count = {};
class PushClientBaseItem {
    constructor(type) {
        this.subEvent = new sub_events_1.SubEvent();
        this.type = type;
        this.RegistrationId = Utilities_1.synUtil.getGUID(true);
    }
    get Type() {
        return this.type;
    }
    get SubEvent() {
        return this.subEvent;
    }
}
class PushClientDocumentItem extends PushClientBaseItem {
    constructor(type, DocId) {
        super(type);
        this.docId = DocId;
    }
    get DocId() {
        return this.docId;
    }
    GetEvent(purpose) {
        return new PushEvent_1.DocumentEvent(this.Type, purpose, this.DocId);
    }
    GetMessageObject(purpose) {
        return new PushEvent_1.MessageObject(this.RegistrationId, this.GetEvent(purpose));
    }
}
class PushClientStructureItem extends PushClientBaseItem {
    constructor(type, parentTypeId, parentDocId, childTypeId, childDocId, structureType) {
        super(type);
        this.parentTypeId = parentTypeId;
        this.parentDocId = parentDocId;
        this.childTypeId = childTypeId;
        this.childDocId = childDocId;
        this.structureType = structureType;
    }
    get ParentTypeId() {
        return this.parentTypeId;
    }
    get ParentDocId() {
        return this.parentDocId;
    }
    get ChildTypeId() {
        return this.childTypeId;
    }
    get ChildDocId() {
        return this.childDocId;
    }
    get StructureType() {
        return this.structureType;
    }
    GetEvent(purpose) {
        return new PushEvent_1.StructureEvent(this.Type, purpose, this.ParentTypeId, this.ParentDocId, this.ChildTypeId, this.ChildDocId, this.StructureType);
    }
    GetMessageObject(purpose) {
        return new PushEvent_1.MessageObject(this.RegistrationId, this.GetEvent(purpose));
    }
}
class PushClientForeigntableItem extends PushClientBaseItem {
    constructor(name) {
        super(PushEvent_1.EventType.foreigntablechanged);
        this.name = name;
    }
    get Name() {
        return this.name;
    }
    GetEvent(purpose) {
        return new PushEvent_1.ForeignTableEvent(this.Type, purpose, this.Name);
    }
    GetMessageObject(purpose) {
        return new PushEvent_1.MessageObject(this.RegistrationId, this.GetEvent(purpose));
    }
}
